<div class="modal fade center-modal-specific" bsModal #subscriptionAdjustUsersModal="bs-modal"
  [config]="{keyboard: false, backdrop: 'static'}" id="SubscriptionAdjustUsersModal" tabindex="-1">
  <div class="modal-dialog modal-dialog-centered adjust-users-modal modal-dialog-scrollable">
    <div class="modal-content rounded-5 bg-popup box-shadow-popup border-all">
      <div class="modal-body pt-10 px-0 pb-0">
        <div class="grid h-100 px-0">
          <div class="h-100">
            <div class="plan-feature-cards-wrapper">
              <div class="row border-bottom">
                <div class="col-11 py-2 px-4">
                  <div class="f-size-15 font-weight-bold tk-proxima-nova mb-10 text-vf-dark">
                    {{ isShowReduceUsers ? 'Reduce users' : 'Oops! we need to adjust your plan' }}
                  </div>
                </div>
                <div class="col-1 py-2 text-right">
                  <button type="button" class="btn pt-0 px-0" aria-label="Close" (click)="closeBeforeActions();">
                    <lucide-icon name="x" [size]="12" [strokeWidth]="2"></lucide-icon>
                  </button>
                </div>
              </div>
              <div class="upgrade-plan-area" *ngIf="!isShowReduceUsers">
                <div class="row justify-content-center">
                  <span class="f-size-18 mt-4 text-vf-medium">You have more users than the <b>{{planName}} Plan allows
                      (max {{maxUsers}} users)</b></span>
                  <span class="f-size-18 text-vf-medium">Please <b>reduce the number of users</b> or choose the
                    <b>Professional Plan</b>.</span>
                </div>
                <div class="row">
                  <div class="col-12 text-center">
                    <button type="button"
                      class="btn cancel-btn hover-shadow rounded-pill py-10 mr-3 pr-3 pl-3 f-size-15"
                      (click)="reduceUsers()">Reduce
                      users</button>
                    <button type="button"
                      class="btn bg-primary border-primary text-white hover-shadow rounded-pill ml-2 py-10 pr-3 pl-3 f-size-15"
                      (click)="switchToProPlan()" *ngIf="selectedPlanId === 1">
                      Choose Professional Plan <lucide-icon name="thumbs-up" [size]="16" [strokeWidth]="2" class="ml-1"></lucide-icon>
                    </button>
                    <a type="button"
                      class="btn bg-primary border-primary text-white hover-shadow rounded-pill ml-2 py-10 pr-3 pl-3 f-size-15"
                      href="https://calendly.com/trovve/trovve-enterprise-plan" target="_blank"
                      *ngIf="selectedPlanId === 0">
                      Contact sales <lucide-icon name="phone" [size]="16" [strokeWidth]="2" class="ml-1"></lucide-icon>
                    </a>
                  </div>
                </div>
                <div class="row">
                  <div class="welcome-options">
                    <div class="welcome-option">
                      <lucide-icon name="rocket" [size]="16" [strokeWidth]="2" class="text-vf-dark mr-2"></lucide-icon> <span
                        class="font-weight-bold mr-2"> Need Assistance?</span>
                      <span class="f-size-14">Our <a class="btn-link text-blue text-underline"
                          href="https://forms.office.com/pages/responsepage.aspx?id=pgyIyWmlpkOJI1BwUax7G-aKh0QROtJBnWlce0FUzcFUMjVXTk1PWVZHMzBJSkhIN0taQVIwRFlaSi4u&origin=lprLink"
                          target="_blank">support team</a> is here to ensure your experience is seamless.</span>
                    </div>
                  </div>
                </div>
              </div>
              <div class="reduce-users-area" *ngIf="isShowReduceUsers">
                <div class="row justify-content-center pb-20">
                  <span class="f-size-18 mt-4 text-vf-medium">You currently have <b>{{noOfUsers}} active users</b>.
                    Here are the maximum users allowed for each plan.</span>
                </div>
                <div class="row justify-content-center py-20 px-20">
                  <div class="col-3 d-flex flex-column">
                    <span class="font-weight-bold text-vf-dark">Starter</span>
                    <span class="allowed-users-pill">4 users</span>
                  </div>
                  <div class="col-3 d-flex flex-column">
                    <span class="font-weight-bold text-vf-dark">Professional</span>
                    <span class="allowed-users-pill">50 users</span>
                  </div>
                  <div class="col-3 d-flex flex-column">
                    <span class="font-weight-bold text-vf-dark">Enterprise</span>
                    <span class="allowed-users-pill">Unlimited</span>
                  </div>
                </div>
                <div class="row justify-content-center py-20 px-20">
                  <div class="users-list">
                    <perfect-scrollbar [config]="config">
                      <ng-template ngFor let-i="index" let-user [ngForOf]="users">
                        <div class="user-card" *ngIf="!user.isDeleted">
                          <div class="row">
                            <div class="col-3 d-flex align-items-center">
                              <span class="text-vf-dark text-truncate font-weight-bold">{{user.fullname}}</span>
                            </div>
                            <div class="col d-flex align-items-center">
                              <span class="user-name text-truncate">{{user.email}}</span>
                            </div>
                            <div class="col-2 d-flex align-items-center justify-content-end">
                              <button type="button" class="btn btn-link text-vf-dark" (click)="removeUser(user)">
                                <lucide-icon name="trash-2" [size]="20" [strokeWidth]="2"></lucide-icon>
                              </button>
                            </div>
                          </div>
                        </div>
                      </ng-template>
                    </perfect-scrollbar>
                  </div>
                </div>
                <div class="row justify-content-center py-20 px-20">
                  <div class="col-12 text-center">
                    <button type="button"
                      class="btn cancel-btn hover-shadow rounded-pill py-10 mr-3 pr-3 pl-3 f-size-15"
                      (click)="hideReduceUsers()">Cancel</button>
                    <button type="button" [disabled]="noOfUsers > maxUsers"
                      class="btn bg-primary border-primary text-white hover-shadow rounded-pill ml-2 py-10 pr-3 pl-3 f-size-15"
                      (click)="saveAdjustedUsers()">
                      Save
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <vf-spinner *ngIf="isSaving"></vf-spinner>